<template>
  <div class="or-cookie__item" v-bind:class="{'or-cookie__item--selected': isSelected}">
    <div class="or-cookie__item-header">
      <h1 v-on:click="selectItem">{{languageString.KOKUAPP[data.name].title}}</h1>
      <div class="or-cookie__toggle"
        v-if="isSelected && data.links.length > 0"
        v-bind:class="{'or-cookie__toggle--disabled' : data.required}">
        <input
          type="checkbox"
          v-model="data.value"
          true-value="yes"
          false-value="no"
          id="check-{{index}}"
          :disabled="data.required"
        >
        <label for="check-{{index}}">{{data.value ? languageString.KOKUAPP.ENABLED : languageString.KOKUAPP.DISABLED}}</label>
      </div>
    </div>

    <div class="or-cookie__item-content" v-show="isSelected">
      <p v-html="languageString.KOKUAPP[data.name].text "></p>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data', 'index', 'tstrings'],

    data () {
      return {
        isSelected: false
      }
    },

    computed: {
      languageString () {
        if (this.tstrings) {
          return this.tstrings
        }
      }
    },

    events: {
      'selectedIndex' (selectedIndex) {
        this.isSelected = false
      }
    },

    methods: {
      selectItem () {
        if (!this.isSelected) {
          this.$dispatch('content-visible', this.index)
        }
        this.isSelected = !this.isSelected
      }
    }
  }
</script>



// WEBPACK FOOTER //
// cookie-item.vue?0d5fc146